import { gql } from "@grandvisionhq/graphql";
import { ShoppinglistBasicFragment } from "../../../fragments/operations/fragments/shopping-list.js";
const addToShoppinglistFragment = gql`
  fragment AddToShoppinglistFragment on AddToShoppinglistSuccessResponse {
    result {
      ...ShoppinglistBasicFragment
    }
  }
  ${ShoppinglistBasicFragment}
`;
const failuresFragment = gql`
  fragment AddToShoppinglistFailureFragment on AddToShoppinglistFailureResponse {
    failures {
      ... on ShoppinglistNotFoundFailure {
        message
      }
      ... on ShoppinglistAuthorizationFailure {
        message
      }
      ... on ShoppinglistInputFailure {
        message
      }
      ... on ShoppinglistFailure {
        message
      }
    }
  }
`;
const ADD_TO_SHOPPING_LIST = gql`
  mutation AddToShoppinglist($input: AddToShoppinglistInput!) {
    addToShoppinglist(input: $input) {
      ...AddToShoppinglistFragment
      ...AddToShoppinglistFailureFragment
    }
  }
  ${addToShoppinglistFragment}
  ${failuresFragment}
`;
export {
  addToShoppinglistFragment,
  ADD_TO_SHOPPING_LIST as default,
  failuresFragment
};
//# sourceMappingURL=add-to-shopping-list.js.map
